import { SepPlansTableProvider } from './SepPlansTableProvider';
import { SepSpendDisplays } from './SepSpendDisplays';
import { NoSepPlansAlert } from './NoSepPlansAlert';

export const SepPlansTab = ({ commonProps, masterScopeJson }) => {
  return (
    <>
      <NoSepPlansAlert />
      <SepSpendDisplays commonProps={commonProps} />
      <SepPlansTableProvider
        commonProps={commonProps}
        masterScopeJson={masterScopeJson}
      />
    </>
  );
};
